/**
 * KanbanSkeleton - Skeleton loader za ceo Kanban board
 * Prikazuje animirani placeholder za board sa bucket-ima i karticama
 */

import React from 'react';
import { Skeleton } from 'antd';
import { KanbanBucketSkeleton } from './KanbanBucketSkeleton';
import './skeletons.css';

interface KanbanSkeletonProps {
  /** Broj bucket-a za prikaz */
  bucketCount?: number;
  /** Prosečan broj kartica po bucket-u */
  cardsPerBucket?: number;
}

export const KanbanSkeleton: React.FC<KanbanSkeletonProps> = ({
  bucketCount = 4,
  cardsPerBucket = 3,
}) => {
  return (
    <div className="kanban-board">
      <div className="kanban-board-header">
        <Skeleton.Input active style={{ width: 200, height: 24 }} />
        <Skeleton.Input
          active
          size="small"
          style={{ width: 300, height: 14, marginTop: 8 }}
        />
      </div>
      <div className="kanban-board-content">
        {Array.from({ length: bucketCount }, (_, index) => (
          <KanbanBucketSkeleton
            key={`bucket-skeleton-${index}`}
            cardCount={cardsPerBucket}
          />
        ))}
      </div>
    </div>
  );
};
